/**
 * ANQ.UserProfile.API 
 * User Profile Service
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UserCreateRequestDto { 
    username: string;
    password: string;
    passwordFormatId?: number;
    passwordSalt?: string;
    email: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    companyName?: string;
    phoneNumber?: string;
    phone?: string;
    active?: boolean;
    isEmailConfirmed?: boolean;
    emailConfirmationCode?: string;
    isSystem?: boolean;
    systemName?: string;
    createdBy?: number;
    accountSetup?: boolean;
    approved?: string;
    applicationId?: number;
    role?: string;
    vasLicenseId?: string;
    vasLicenseActiveDate?: Date;
    vasLicenseExpiryDate?: Date;
    countryName?: string;
    countryId?: number;
    countryCode?: string;
    addressLocation?: string;
}